import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

// const headerNames = ['ReceiptNo', 'Payment Type', 'Amount', 'Accountant'];
// const rowValues = [
//   { accessValue: 'receiptNo' },
//   { accessValue: 'paymentType' },
//   {
//     accessValue: 'amount',
//   },
//   { accessValue: 'createdBy' },
// ];
//const dataList=[] array of objects data
const ReusableMUITable = ({
  headerNames = [],
  rowValues = [],
  dataList = [],
}) => {
  return (
    <div className='size-full'>
      {headerNames?.length > 0 &&
        rowValues?.length > 0 &&
        dataList?.length > 0 && (
          <TableContainer
            component={Paper}
            variant='outlined'
            sx={{
              maxHeight: 400,
              overflow: 'auto',
            }}
          >
            <Table stickyHeader size='small' sx={{ minWidth: 700 }}>
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f8fafc' }}>
                  <TableCell className='text-blue-600'>
                    <strong>SNO</strong>
                  </TableCell>
                  {headerNames?.map((name, index) => (
                    <TableCell key={index} className='text-blue-600'>
                      <strong>{name}</strong>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {dataList?.map(
                  (
                    dataListObj, //dataListObj means each object of the datalist
                    index,
                  ) => (
                    <TableRow
                      key={dataListObj?.id || index}
                      hover
                      sx={{
                        '&:nth-of-type(odd)': {
                          backgroundColor: '#fafafa',
                        },
                      }}
                    >
                      {' '}
                      <TableCell>{index + 1}</TableCell>
                      {rowValues?.map((rowValuesObj) => (
                        <>
                          <TableCell key={rowValuesObj.accessValue}>
                            {rowValuesObj.renderCell
                              ? rowValuesObj.renderCell(
                                  //if any render function is there then
                                  // call function(access keyname,owd data object)
                                  rowValuesObj.accessValue,
                                  dataListObj,
                                ) //else return just value
                              : dataListObj[rowValuesObj.accessValue]}
                          </TableCell>
                        </>
                      ))}
                    </TableRow>
                  ),
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
    </div>
  );
};
export default ReusableMUITable;
export function CapitalizeFirstLetter(word = '') {
  if (!word) return '';
  else {
    return word[0].toUpperCase() + word.slice(1);
  }
}
export function getTableColumns(firstObject) {
  if (Object.keys(firstObject)?.length == 0) return [];
  return Object.keys(firstObject)
    ?.map((item) => CapitalizeFirstLetter(item))
    .filter((item) => item.toLowerCase() !== 'id');
}
